import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Form, Button, Modal } from 'react-bootstrap' 

import { api, getBranchOwner, get, post, put } from "@config"
import { setLoading } from "@inspinia-react/actions"
import { setPis } from '@taxes/actions'
import { notification } from 'antd'

function PIS(props) {
    const branch = getBranchOwner().id
    const [result, setResult] = React.useState([])
    const [show, ShowModal] = React.useState(false)
    const [name, setName] = React.useState("")
    const [cst, setCst] = React.useState()
    const [calc, setCalc] = React.useState()

    const url = `${api.pis}?branch_owner=${branch}`

    React.useEffect(() => {
        setTimeout(() => {
            get(url, e => setResult(e))
        }, 400)
    }, [])

    function save() {
        const payload = pis => {
            props.setPis(pis)
            get(url, e => setResult(e))

            notification.open({
                message: "Criado com sucesso",
                type: "success",
                key: 132,
                duration: 3
            })
            ShowModal(false)
        }
        post(url, { name, cst, calculo: calc }, payload)
    }
    function setPIS(e) {
        const p = result[e.target.selectedIndex - 1]
        props.setPis(p)
    }

    React.useEffect(() => {
        if (props.pis.id && result.length) {
            props.setPis(props.pis)
        } else {
        }
    }, [props.ipi, result])

    return <React.Fragment>
        <p className="lead mb-1">PIS</p>
        <span style={{ cursor: 'pointer' }} onClick={() => ShowModal(true)} className="badge badge-primary">Criar Novo</span>
        <Form.Control disabled={props.loading} as="select" onChange={setPIS}>
            <option >Selecione o PIS </option>
            {
                result.map(item => <option selected={props.pis.id === item.id} key={item.id} value={item.id}>{item.name}</option>)
            }
        </Form.Control>
        <Modal show={show}>
            <Modal.Header>
                <h2 className="text-center">
                    Novo PIS
                </h2>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Label>
                        Nome
                    </Form.Label>
                    <Form.Control onChange={e => setName(e.target.value)} />
                </Form.Group>
                <Form.Group>
                    <Form.Label>
                        CST
                    </Form.Label>
                    <Form.Control
                        onChange={e => setCst(e.target.value)} as="select"
                    >
                        <option value="">Selecione</option>
                        <option value="01">01 - Operação Tributável com Alíquota Básica</option>
                        <option value="02">02 - Operação Tributável com Alíquota Diferenciada</option>
                        <option value="03">03 - Operação Tributável com Alíquota por Unidade de Medida de Produto</option>
                        <option value="04">04 - Operação Tributável Monofásica - Revenda a Alíquota Zero</option>
                        <option value="05">05 - Operação Tributável por Substituição Tributária</option>
                        <option value="06">06 - Operação Tributável a Alíquota Zero</option>
                        <option value="07">07 - Operação Isenta da Contribuição</option>
                        <option value="08">08 - Operação sem Incidência da Contribuição</option>
                        <option value="09">09 - Operação com Suspensão da Contribuição</option>

                        <option value="49">49 - Outras Operações de Saída</option>
                        <option value="50">50 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Interno</option>
                        <option value="51">51 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não Tributada no Mercado Interno</option>
                        <option value="52">52 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação</option>
                        <option value="53">53 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno</option>
                        <option value="54">54 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas no Mercado Interno e de Exportação</option>
                        <option value="55">55 - Operação com Direito a Crédito - Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação</option>
                        <option value="56">56 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação</option>

                        <option value="60">60 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno</option>
                        <option value="61">61 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno</option>
                        <option value="62">62 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação</option>
                        <option value="63">63 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno</option>
                        <option value="64">64 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação</option>
                        <option value="65">65 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação</option>
                        <option value="66">66 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação</option>
                        <option value="67">67 - Crédito Presumido - Outras Operações</option>

                        <option value="70">70 - Operação de Aquisição sem Direito a Crédito</option>
                        <option value="71">71 - Operação de Aquisição com Isenção</option>
                        <option value="72">72 - Operação de Aquisição com Suspensão</option>
                        <option value="73">73 - Operação de Aquisição a Alíquota Zero</option>
                        <option value="74">74 - Operação de Aquisição sem Incidência da Contribuição</option>
                        <option value="75">75 - Operação de Aquisição por Substituição Tributária </option>

                        <option value="98">98 - Outras Operações de Entrada</option>
                        <option value="99">99 - Outras Operações</option>

                    </Form.Control>
                </Form.Group>
                <Form.Group>
                    <Form.Label>
                        Cálculo
                    </Form.Label>
                    <Form.Control onChange={e => setCalc(e.target.value)} as="select">
                        <option value="">Selecione</option>
                        <option value="1">Porcentagem</option>
                        <option value="2">Valor</option>
                    </Form.Control>
                </Form.Group>

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => {
                    ShowModal(false)
                    setName('')
                    setCst('')
                }}>
                    Cancelar
                </Button>
                <Button onClick={save}>
                    Salvar
                </Button>
            </Modal.Footer>
        </Modal>
    </React.Fragment>
}

const mapStateToProps = state => ({
    loading: state.loading,
    pis: state.pis
})
const mapDispatchToProps = dispatch => bindActionCreators({
    setLoading,
    setPis
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(PIS)


// WEBPACK FOOTER //
// ./src/components/pages/fiscal/taxes/pis/index.jsx